var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-container"},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:({
      placement: 'top',
      content: _vm.status === 'Elected' ? _vm.tooltips.v_list.elected_badge : _vm.tooltips.v_list.not_elected_badge
    }),expression:"{\n      placement: 'top',\n      content: status === 'Elected' ? tooltips.v_list.elected_badge : tooltips.v_list.not_elected_badge\n    }",modifiers:{"top":true}}],staticClass:"validator-status",class:_vm.status_class,attrs:{"title":_vm.status_detailed}},[_vm._v(_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }